(function () {
  "use strict";

  function md5(value) {
    value = unescape(encodeURIComponent(value));

    function cmn(q, a, b, x, s, t) {
      a = (a + q + x + t) | 0;
      return (((a << s) | (a >>> (32 - s))) + b) | 0;
    }

    function ff(a, b, c, d, x, s, t) {
      return cmn((b & c) | (~b & d), a, b, x, s, t);
    }

    function gg(a, b, c, d, x, s, t) {
      return cmn((b & d) | (c & ~d), a, b, x, s, t);
    }

    function hh(a, b, c, d, x, s, t) {
      return cmn(b ^ c ^ d, a, b, x, s, t);
    }

    function ii(a, b, c, d, x, s, t) {
      return cmn(c ^ (b | ~d), a, b, x, s, t);
    }

    function cycle(state, block) {
      var a = state[0];
      var b = state[1];
      var c = state[2];
      var d = state[3];

      a = ff(a, b, c, d, block[0], 7, -680876936);
      d = ff(d, a, b, c, block[1], 12, -389564586);
      c = ff(c, d, a, b, block[2], 17, 606105819);
      b = ff(b, c, d, a, block[3], 22, -1044525330);
      a = ff(a, b, c, d, block[4], 7, -176418897);
      d = ff(d, a, b, c, block[5], 12, 1200080426);
      c = ff(c, d, a, b, block[6], 17, -1473231341);
      b = ff(b, c, d, a, block[7], 22, -45705983);
      a = ff(a, b, c, d, block[8], 7, 1770035416);
      d = ff(d, a, b, c, block[9], 12, -1958414417);
      c = ff(c, d, a, b, block[10], 17, -42063);
      b = ff(b, c, d, a, block[11], 22, -1990404162);
      a = ff(a, b, c, d, block[12], 7, 1804603682);
      d = ff(d, a, b, c, block[13], 12, -40341101);
      c = ff(c, d, a, b, block[14], 17, -1502002290);
      b = ff(b, c, d, a, block[15], 22, 1236535329);

      a = gg(a, b, c, d, block[1], 5, -165796510);
      d = gg(d, a, b, c, block[6], 9, -1069501632);
      c = gg(c, d, a, b, block[11], 14, 643717713);
      b = gg(b, c, d, a, block[0], 20, -373897302);
      a = gg(a, b, c, d, block[5], 5, -701558691);
      d = gg(d, a, b, c, block[10], 9, 38016083);
      c = gg(c, d, a, b, block[15], 14, -660478335);
      b = gg(b, c, d, a, block[4], 20, -405537848);
      a = gg(a, b, c, d, block[9], 5, 568446438);
      d = gg(d, a, b, c, block[14], 9, -1019803690);
      c = gg(c, d, a, b, block[3], 14, -187363961);
      b = gg(b, c, d, a, block[8], 20, 1163531501);
      a = gg(a, b, c, d, block[13], 5, -1444681467);
      d = gg(d, a, b, c, block[2], 9, -51403784);
      c = gg(c, d, a, b, block[7], 14, 1735328473);
      b = gg(b, c, d, a, block[12], 20, -1926607734);

      a = hh(a, b, c, d, block[5], 4, -378558);
      d = hh(d, a, b, c, block[8], 11, -2022574463);
      c = hh(c, d, a, b, block[11], 16, 1839030562);
      b = hh(b, c, d, a, block[14], 23, -35309556);
      a = hh(a, b, c, d, block[1], 4, -1530992060);
      d = hh(d, a, b, c, block[4], 11, 1272893353);
      c = hh(c, d, a, b, block[7], 16, -155497632);
      b = hh(b, c, d, a, block[10], 23, -1094730640);
      a = hh(a, b, c, d, block[13], 4, 681279174);
      d = hh(d, a, b, c, block[0], 11, -358537222);
      c = hh(c, d, a, b, block[3], 16, -722521979);
      b = hh(b, c, d, a, block[6], 23, 76029189);
      a = hh(a, b, c, d, block[9], 4, -640364487);
      d = hh(d, a, b, c, block[12], 11, -421815835);
      c = hh(c, d, a, b, block[15], 16, 530742520);
      b = hh(b, c, d, a, block[2], 23, -995338651);

      a = ii(a, b, c, d, block[0], 6, -198630844);
      d = ii(d, a, b, c, block[7], 10, 1126891415);
      c = ii(c, d, a, b, block[14], 15, -1416354905);
      b = ii(b, c, d, a, block[5], 21, -57434055);
      a = ii(a, b, c, d, block[12], 6, 1700485571);
      d = ii(d, a, b, c, block[3], 10, -1894986606);
      c = ii(c, d, a, b, block[10], 15, -1051523);
      b = ii(b, c, d, a, block[1], 21, -2054922799);
      a = ii(a, b, c, d, block[8], 6, 1873313359);
      d = ii(d, a, b, c, block[15], 10, -30611744);
      c = ii(c, d, a, b, block[6], 15, -1560198380);
      b = ii(b, c, d, a, block[13], 21, 1309151649);
      a = ii(a, b, c, d, block[4], 6, -145523070);
      d = ii(d, a, b, c, block[11], 10, -1120210379);
      c = ii(c, d, a, b, block[2], 15, 718787259);
      b = ii(b, c, d, a, block[9], 21, -343485551);

      state[0] = (state[0] + a) | 0;
      state[1] = (state[1] + b) | 0;
      state[2] = (state[2] + c) | 0;
      state[3] = (state[3] + d) | 0;
    }

    function block(valueBlock) {
      var blocks = [];
      var index;
      for (index = 0; index < 64; index += 4) {
        blocks[index >> 2] =
          valueBlock.charCodeAt(index) +
          (valueBlock.charCodeAt(index + 1) << 8) +
          (valueBlock.charCodeAt(index + 2) << 16) +
          (valueBlock.charCodeAt(index + 3) << 24);
      }
      return blocks;
    }

    function digest(input) {
      var length = input.length;
      var state = [1732584193, -271733879, -1732584194, 271733878];
      var index;
      var tail;

      for (index = 64; index <= length; index += 64) {
        cycle(state, block(input.substring(index - 64, index)));
      }

      input = input.substring(index - 64);
      tail = new Array(16).fill(0);
      for (index = 0; index < input.length; index += 1) {
        tail[index >> 2] |= input.charCodeAt(index) << ((index % 4) << 3);
      }
      tail[index >> 2] |= 0x80 << ((index % 4) << 3);

      if (index > 55) {
        cycle(state, tail);
        tail = new Array(16).fill(0);
      }

      tail[14] = length * 8;
      cycle(state, tail);
      return state;
    }

    function hex(number) {
      var characters = "0123456789abcdef";
      var output = "";
      var index;
      for (index = 0; index < 4; index += 1) {
        output +=
          characters.charAt((number >> (index * 8 + 4)) & 0x0f) +
          characters.charAt((number >> (index * 8)) & 0x0f);
      }
      return output;
    }

    return digest(value).map(hex).join("");
  }

  function setFeedback(form, type, message) {
    var success = form.querySelector("[data-contact-success]");
    var error = form.querySelector("[data-contact-error]");

    if (success) {
      success.hidden = type !== "success";
      success.textContent = type === "success" ? message : "";
    }
    if (error) {
      error.hidden = type !== "error";
      error.textContent = type === "error" ? message : "";
    }

    var active = type === "success" ? success : error;
    if (active) {
      active.focus();
    }
  }

  function submit(root, form) {
    var submitUrl = (root.dataset.contactSubmitUrl || "").trim();
    var secret = (root.dataset.contactSubmitSecret || "").trim();
    var errorMessage = root.dataset.contactErrorMessage || "Submission failed. Please try again later.";
    var successMessage = root.dataset.contactSuccessMessage || "Thanks! We will get back to you as soon as possible.";
    var submitButton = form.querySelector('button[type="submit"]');
    var body = new URLSearchParams(new FormData(form));
    var timestamp = String(Math.floor(Date.now() / 1000));
    var signature = md5(body.toString() + "&time=" + timestamp + "&secret=" + secret);
    var request = new XMLHttpRequest();

    if (!submitUrl || !secret) {
      setFeedback(form, "error", errorMessage);
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute("aria-busy", "true");
    }
    setFeedback(form, "", "");

    request.open("POST", submitUrl, true);
    request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
    request.setRequestHeader("X-Sign", signature);
    request.setRequestHeader("X-Timestamp", timestamp);
    request.onreadystatechange = function () {
      var response;
      var message;

      if (request.readyState !== 4) {
        return;
      }

      try {
        response = JSON.parse(request.responseText || "{}");
      } catch (parseError) {
        response = {};
      }

      if (request.status >= 200 && request.status < 300 && Number(response.code) === 200) {
        form.reset();
        setFeedback(form, "success", successMessage);
      } else {
        message = response.msg || response.message || errorMessage;
        setFeedback(form, "error", message);
      }

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute("aria-busy");
      }
    };
    request.onerror = function () {
      setFeedback(form, "error", errorMessage);
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute("aria-busy");
      }
    };
    request.send(body.toString());
  }

  function init() {
    document.querySelectorAll(".product-selection-page").forEach(function (root) {
      root.querySelectorAll("[data-product-selection-contact]").forEach(function (form) {
        if (form.dataset.contactSubmitInitialized === "true") {
          return;
        }

        form.addEventListener("submit", function (event) {
          event.preventDefault();
          if (!form.reportValidity()) {
            return;
          }
          submit(root, form);
        });
        form.dataset.contactSubmitInitialized = "true";
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
